module.exports = __webpack_public_path__ + "static/media/correctIcon.d53ca135.svg";